import React from 'react';
import SpearDriveWebsite from './components/mainComponent';

function App() {
  return (
    <div className="App">
      <SpearDriveWebsite />
    </div>
  );
}

export default App;